export type ValidatorResult = { ok: boolean; message?: string };

export function dateIsoPattern(allowTime: boolean = true): RegExp {
  const base = "^\\d{4}-\\d{2}-\\d{2}";
  return allowTime
    ? new RegExp(`${base}(?:[T\\s]\\d{2}:\\d{2}:\\d{2})?$`)
    : new RegExp(`${base}$`);
}

const fns = {
  nonEmpty: (input: string) => !!input && input.trim().length > 0,
  regex: (input: string, pattern?: string) => {
    if (!pattern) return true;
    try { return new RegExp(pattern).test(input ?? ""); } catch { return false; }
  },
  stringRegex: (
    input: string,
    cfg?: { pattern?: string; flags?: string; minLength?: number; maxLength?: number }
  ) => {
    const s = (input ?? "");
    if (!cfg) return true;
    const { pattern, flags, minLength, maxLength } = cfg;

    const len = s.trim().length;
    if (typeof minLength === "number" && len < minLength) return false;
    if (typeof maxLength === "number" && len > maxLength) return false;

    if (!pattern) return true;
    try {
      const re = new RegExp(pattern, flags || undefined);
      return re.test(s);
    } catch {
      return false;
    }
  },

  currencyPattern: (
    input: string,
    cfg?: {
      pattern?: string;
      min?: number;
      max?: number;
      decimals?: number;
      allowCommaDecimal?: boolean;
      allowDotDecimal?: boolean;
    }
  ) => {
    const s = (input ?? "").trim();
    if (s === "") return true;

    const {
      pattern,
      min,
      max,
      decimals = 2,
      allowCommaDecimal = true,
      allowDotDecimal = true,
    } = cfg || {};

    if (pattern) {
      try {
        if (!new RegExp(pattern).test(s)) return false;
      } catch { return false; }
    } else {
      const sep = allowCommaDecimal && allowDotDecimal
        ? "[.,]"
        : allowCommaDecimal
          ? ","
          : allowDotDecimal
            ? "\\."
            : "";

      const re = decimals > 0 && sep
        ? new RegExp(`^\\d+(?:${sep}\\d{1,${decimals}})?$`)
        : /^\d+$/;

      if (!re.test(s)) return false;
    }

    const normalized = s.replace(",", ".");
    const n = Number.parseFloat(normalized);
    if (Number.isNaN(n)) return false;

    if (decimals >= 0) {
      const dotIdx = normalized.indexOf(".");
      if (dotIdx >= 0) {
        const frac = normalized.slice(dotIdx + 1);
        if (frac.length > decimals) return false;
      }
    }

    if (typeof min === "number" && n < min) return false;
    if (typeof max === "number" && n > max) return false;

    return true;
  },

  between: (input: string, min?: number, max?: number) => {
    const v = Number(input); if (Number.isNaN(v)) return false;
    if (min != null && v < min) return false;
    if (max != null && v > max) return false;
    return true;
  },
  max: (input: string, max?: number) => {
    const v = Number(input); if (Number.isNaN(v) || max == null) return false;
    return v <= max;
  },
  min: (input: string, min?: number) => {
    const v = Number(input); if (Number.isNaN(v) || min == null) return false;
    return v >= min;
  },
  email: (input: string) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(input ?? ""),
  phone: (input: string) => /^\+?[0-9. ()-]{3,99}$/.test(input ?? ""),
  dateISO: (input: string, cfg?: { allowTime?: boolean; min?: string; max?: string }) => {
    const s = (input ?? "").trim();
    if (s === "") return true;

    const allowTime = cfg?.allowTime !== false;
    const re = dateIsoPattern(allowTime);
    if (!re.test(s)) return false;

    const toDateOnly = (x: string) => x.slice(0, 10);
    const val = toDateOnly(s);

    if (cfg?.min) {
      const min = toDateOnly(cfg.min);
      if (val < min) return false;
    }
    if (cfg?.max) {
      const max = toDateOnly(cfg.max);
      if (val > max) return false;
    }
    console.log("ok")
    return true;
  },
} as const;

export function runValidator(
  name?: string,
  args: any[] = [],
  input: string = ""
): ValidatorResult {
  console.log(name)
  if (!name) return { ok: true };
  const fn = (fns as any)[name];
  if (!fn) return { ok: true };
  const ok = fn(input, ...(args ?? []));
  return ok ? { ok } : { ok, message: `Validation '${name}' failed` };
}
